<template>
  <div>
    <hr>
    <div class="d-flex align-items-center justify-content-between mb-3">
      <label class="mb-0">
        <i class="far fa-file pr-1" />
        {{ $t('menu.import') }}
      </label>

      <div @click="$emit('close')">
        <i class="fas fa-times secondary-icon" />
      </div>
    </div>

    <div
      class="flex-grow-1"
    >
      <div
        v-if="validationError"
        class="text-center mb-3"
      >
        <div class="d-flex align-items-center text-danger justify-content-center">
          <i class="fa-solid fa-triangle-exclamation fa-2x mr-2" />
          {{ $t('import.validationError') }}
        </div>
      </div>

      <FileUpload
        v-if="!importFile || fileValidation.length > 0"
        class="upload h-100 mt-1 d-flex align-items-center justify-content-center"
        @upload="validateFile"
      />
      <div
        v-if="importPending"
        class="text-center"
      >
        <Loader />
      </div>

      <div v-if="fileValidation.length === 0 && importFile && !importPending">
        <hr>
        <div class="d-flex justify-content-between">
          <div class="font-weight-bold text-primary">
            Nie znaleziono błędów. Możesz zaimportować plik.
          </div>
          <div>
            <button
              class="btn btn-sm btn-primary"
              :disabled="importPending"
              @click="upload"
            >
              {{ $t('shop.confirmImport') }}
              <i class="fa-regular fa-arrow-right pl-2" />
            </button>
          </div>
        </div>
        <hr>
      </div>
      <div v-else-if="fileValidation.length > 0">
        <div class="font-weight-bold mt-4">
          {{ $t('import.errors') }}:
        </div>
        <div
          v-for="(error, i) in fileValidation"
          :key="`meal_${i}`"
        >
          <ShopImportError v-bind="error" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/api/axios';
import FileUpload from '@/components/FileUpload';
import ShopImportError from '@/components/shop/ShopImportError';

export default {
  props: {
    catalogId: String,
  },
  data: () => ({
    importFile: null,
    importPending: false,
    fileValidation: [],
    validationError: false,
  }),
  components: {
    FileUpload,
    ShopImportError,
  },
  methods: {
    validateFile(file) {
      this.validationError = false;
      this.importFile = file;
      const formData = new FormData();
      formData.append('file', file);

      this.importPending = true;

      axios.post(`shop/${this.catalogId}/meals/import/validate`, formData, {
        params: {
          catalogId: this.catalogId,
        },
      })
        .then(({ data }) => {
          this.fileValidation = data.errors || [];
        })
        .catch(() => {
          this.validationError = true;
          this.importFile = null;
        })
        .finally(() => {
          this.importPending = false;
        });
    },
    upload() {
      this.importPending = true;
      const formData = new FormData();
      formData.append('file', this.importFile);

      axios.post(`shop/${this.catalogId}/meals/import`, formData, {
        params: {
          catalogId: this.catalogId,
        },
      })
        .then(() => {
          this.$emit('close');
        })
        .finally(() => {
          this.importPending = false;
        });
    },
  },
};
</script>
